import { render } from "./StatsTab.vue?vue&type=template&id=1adf2a64&scoped=true"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"

import "./StatsTab.vue?vue&type=style&index=0&id=1adf2a64&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adf2a64"]])

export default __exports__